import React from 'react'
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'
import useManageProjectStore from '../../../../stores/manageProject/useManageProjectStore'
import useTranslate from '../../../../i18n/useTranslate'
import * as dateUtil from '../../../../utilities/date'
import useDisplayUpdater from './useDisplayUpdater'

type DisplayUpdaterViewType = DisplayUpdaterType
const DisplayUpdaterView: React.FC<DisplayUpdaterViewType> = (props) => {
    const displayUpdater = useDisplayUpdater()
    const translate = useTranslate()
    const projectStore = useManageProjectStore()

    return (
        (projectStore?.currentPageUpdater && (
            <Grid container item xs={12} justify="flex-end">
                {translate.get('LABEL.UPDATER')} :{' '}
                {translate.languageStore.currentLanguage === translate.languageKey.th
                    ? projectStore?.currentPageUpdater?.name_th
                    : projectStore?.currentPageUpdater?.name_en}
                &nbsp;&nbsp;
                {translate.get('LABEL.UPDATE_DATE')} :{' '}
                {translate.languageStore.currentLanguage === translate.languageKey.th
                    ? dateUtil.convertDateToFormatTH(projectStore?.currentPageUpdater?.date)
                    : dateUtil.convertDateToFormatEN(projectStore?.currentPageUpdater?.date)}
            </Grid>
        )) ||
        null
    )
}
type DisplayUpdaterType = {}
const DisplayUpdater: React.FC<DisplayUpdaterType> = (props) => {
    return <DisplayUpdaterView {...props} />
}

export default DisplayUpdater
